import { Alert, Snackbar as MuiSnackbar } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

/***
 * Snackbar component - provides brief pop up messages, also known as a Toast
 * @param open if true, Snackbar is open
 * @param autoHideDuration number of milliseconds to display before calling the onClose function
 * @param severity the severity of alert to display, this defines color and icon used [info, success, warning, error]
 * @param allowClickaway whether to dismiss when the user clicks elsewhere
 * @param allowDismiss whether to show a dismiss icon on the snackbar
 * @param children node content to display inside Alert
 * @param onClose callback fired when the component requests to be closed.
 * @returns {JSX.Element} Snackbar
 */
export function Snackbar({
  open,
  autoHideDuration = 3000,
  severity = "info",
  allowClickaway = false,
  allowDismiss = true,
  children,
  onClose
}) {
  const handleDismiss = (event, reason) => {
    if (!allowClickaway && reason === "clickaway") {
      return;
    }

    onClose();
  };

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleDismiss}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        severity={severity}
        variant="filled"
        onClose={allowDismiss ? onClose : undefined}
      >
        {children}
      </Alert>
    </MuiSnackbar>
  );
}

Snackbar.propTypes = {
  open: PropTypes.bool,
  autoHideDuration: PropTypes.number,
  severity: PropTypes.string,
  allowDismiss: PropTypes.bool,
  allowClickaway: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.string,
    PropTypes.node
  ]),
  onClose: PropTypes.func
};
